import { NapaDatePeriod, NapaDateRange, NapaDateRangePeriod } from '@core/models/date.models';
import { getThisMonthPeriod, getThisWeekPeriod } from '@core/utils/period.utils';
import { generateTimeOptions, parseTimePoint } from '@core/utils/time.utils';
import { EnvironmentName } from '@core/models/environment.models';
import { WlcmOption } from '@wlcm/angular/core';
import { environment } from '@environment';

export const TIME_OPTIONS: WlcmOption[] = [
  new WlcmOption('7:00', '7:00am'),
  new WlcmOption('8:00', '8:00am'),
  new WlcmOption('9:00', '9:00am'),
  new WlcmOption('10:00', '10:00am'),
  new WlcmOption('11:00', '11:00am'),
  new WlcmOption('12:00', '12:00pm'),
  new WlcmOption('12:30', '12:30pm'),
  new WlcmOption('13:30', '1:30pm'),
  new WlcmOption('14:30', '2:30pm'),
  new WlcmOption('15:30', '3:30pm'),
];

export const SESSION_TIME_OPTIONS: WlcmOption[] = TIME_OPTIONS.filter((option: WlcmOption) => {
  const { hours } = parseTimePoint(option.value as string);
  return hours >= 8 && hours <= 19;
});

export const SCHEDULER_SESSION_TIME_OPTIONS: WlcmOption[] = generateTimeOptions(8, 19);

export const DATE_PERIOD_OPTIONS: WlcmOption[] = [
  { value: NapaDatePeriod.ALL_DATES, viewValue: 'All Dates' },
  { value: NapaDatePeriod.THIS_WEEK, viewValue: 'This Week' },
  { value: NapaDatePeriod.THIS_MONTH, viewValue: 'This Month' },
];

export const DATE_RANGE_PERIOD: { [key in NapaDateRangePeriod]: NapaDateRange } = {
  [NapaDatePeriod.THIS_WEEK]: getThisWeekPeriod(),
  [NapaDatePeriod.THIS_MONTH]: getThisMonthPeriod(),
};

export const TIME_ZONE_OPTIONS: WlcmOption[] = [
  new WlcmOption('America/New_York', 'US - New York (EST)'),
  new WlcmOption('America/Chicago', 'US - Chicago (CST)'),
  new WlcmOption('America/Denver', 'US - Denver (MST)'),
  new WlcmOption('America/Los_Angeles', 'US - Los Angeles (PST)'),
  new WlcmOption('Europe/London', 'UK - London (GMT)'),
  new WlcmOption('Australia/Perth', 'AU - Perth (AWST)'),
  new WlcmOption('Australia/Adelaide', 'AU - Adelaide (ACST)'),
  new WlcmOption('Australia/Sydney', 'AU - Sydney (AEST)'),
  new WlcmOption('Australia/Brisbane', 'AU - Brisbane (AEST)'),
];

if (environment.name === EnvironmentName.DEV || environment.name === EnvironmentName.STAGE) {
  TIME_ZONE_OPTIONS.push(new WlcmOption('Europe/Kyiv', 'UA - Kyiv (EET)'));
  TIME_ZONE_OPTIONS.push(new WlcmOption('Europe/Lisbon', 'PT - Lisbon (WEST)'));
}
